export default __webpack_public_path__ + "static/media/driver_gray.ad93d5c2.svg";